import PropTypes from 'prop-types';

export const hotkey = {
  key: PropTypes.string,
  when: PropTypes.func,
  command: PropTypes.func,
};
